
/**
 * Finds the ordinal of the given item within the list of all items
 * (sorted on offset) and returns a string with the ordinal appended.
 *
 * If an item is normally named `Item`, it might be returned as `Item
 * #2`
 */
export function decorateNameWithOrdinal<T extends {
    id: string
    name: string
    offset: number
}>(allItems: T[], itemToDecorate: T): string {
    const sameName = [...allItems]
        .sort((a, b) => a.offset - b.offset)
        .filter(item => item.name === itemToDecorate.name)

    if (sameName.length <= 0) {
        throw Error(`Expected at least 1 match, found none: ${itemToDecorate}, ${allItems}`)
    }

    if (sameName.length === 1) {
        return itemToDecorate.name
    }

    const index = sameName.findIndex(item => item.id === itemToDecorate.id)

    if (index <= -1) {
        throw Error(`Item not found in set of all items: ${itemToDecorate}, ${allItems}`)
    }

    return `${itemToDecorate.name} #${index + 1}`
}
